// React Lazily
import { lazily } from 'react-lazily'

// Interfaces
import { IRoute } from 'routes/route.interface'

// Constant
import { CONTENT_URL, CONTENT_MODULE } from 'constant/url.constant'
import { LAYOUT } from 'constant/layout.constant'

// UI
const { ContentAboutUsIndex } = lazily(() => import('pages/back-office/content-management/about-us'))

const contentAboutUsRoutes: IRoute[] = [
  {
    path: CONTENT_URL.ABOUT_US,
    component: ContentAboutUsIndex,
    layout: LAYOUT.BACK_OFFICE,
    exact: true,
    meta: {
      module: CONTENT_MODULE,
      requireAuth: true,
      attrs: { label: 'contentManagementAboutUs.aboutUs', accessCodes: [553] },
    },
  },
]

export { contentAboutUsRoutes }
